import { render, staticRenderFns } from "./RegistrosInvalidos.vue?vue&type=template&id=57225770&"
import script from "./RegistrosInvalidos.vue?vue&type=script&lang=js&"
export * from "./RegistrosInvalidos.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosInvalidos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports